import { propagate, SatRec, EcfVec3 } from "satellite.js";

import dayjs from "dayjs";

export function getPositionFromSatrec(satrec: SatRec, time: Dayjs) {
  const timeDate = time.toDate();
  const positionAndVelocity = propagate(satrec, timeDate);
  const positionEci = positionAndVelocity.position;
  try {
    if (typeof positionEci === "boolean") {
      throw new Error("positionEci is a boolean");
    }
    // const positionEcf = eciToEcf(positionEci, gstime(time));
    const { x, y, z } = positionEci as EcfVec3<number>;
    return {
      x,
      y,
      z
    };
  } catch (error) {
    return undefined;
  }
}

export function getSunDirection(time: Dayjs) {
  const JD =
    367 * time.utc().get("year") -
    Math.floor(
      (7.0 *
        (time.utc().get("year") +
          Math.floor((time.utc().get("month") + 9.0) / 12.0))) /
        4.0
    ) +
    Math.floor((275.0 * time.utc().get("month")) / 9.0) +
    time.utc().get("date") +
    1721013.5 +
    time.utc().get("hour") / 24.0 +
    time.utc().get("minute") / 1440.0 +
    time.utc().get("second") / 86400.0;

  let pi = 3.14159265359;
  let UT1 = (JD - 2451545) / 36525;
  let longMSUN = 280.4606184 + 36000.77005361 * UT1;
  let mSUN = 357.5277233 + 35999.05034 * UT1;
  let ecliptic =
    longMSUN +
    1.914666471 * Math.sin((mSUN * pi) / 180) +
    0.918994643 * Math.sin((2 * mSUN * pi) / 180);
  let eccen = 23.439291 - 0.0130042 * UT1;

  let x = Math.cos((ecliptic * pi) / 180);
  let y = Math.cos((eccen * pi) / 180) * Math.sin((ecliptic * pi) / 180);
  let z = Math.sin((eccen * pi) / 180) * Math.sin((ecliptic * pi) / 180);

  // const positionEcf = eciToEcf({ x, y, z }, gstime(time));

  return { x, y, z };
}

export function getEarthRotationAngle(time: Dayjs) {
  const initialAngleInRad = (280.4606184 * Math.PI) / 180;
  const angularVelocityInRad = (360.98564736 * Math.PI) / 180;

  const timeDifference = time.diff(
    dayjs("2000-01-01T12:00:00Z"),
    "millisecond"
  );

  const earthRotationAngle =
    initialAngleInRad +
    angularVelocityInRad * (timeDifference / (24 * 60 * 60 * 1000));
  return earthRotationAngle;
}

export const interpolatePosition = (
  points: number[],
  timeArray: number[],
  currentTime: number,
  index: number
) => {
  if (index === 0) {
    return {
      x: points[0],
      y: points[1],
      z: points[2]
    };
  }

  const prevTime = timeArray[index - 1];
  const nextTime = timeArray[index];
  const prevX = points[(index - 1) * 3];
  const prevY = points[(index - 1) * 3 + 1];
  const prevZ = points[(index - 1) * 3 + 2];
  const nextX = points[index * 3];
  const nextY = points[index * 3 + 1];
  const nextZ = points[index * 3 + 2];

  const t = (currentTime - prevTime) / (nextTime - prevTime);

  const x = prevX + (nextX - prevX) * t;
  const y = prevY + (nextY - prevY) * t;
  const z = prevZ + (nextZ - prevZ) * t;

  return { x, y, z };
};

export const getOrbitPositions = (satrec: SatRec, time: Dayjs) => {
  let arr = [];
  const twoPi = Math.PI * 2;
  const periodSeconds = parseInt(String((twoPi / satrec.no) * 60));
  const resolution = 600;
  const interval = parseInt(String(periodSeconds / resolution));

  const halfPeriodSecond = parseInt(String(periodSeconds / 2));

  for (
    let i = -halfPeriodSecond - interval;
    i <= halfPeriodSecond + interval;
    i += interval
  ) {
    const position = getPositionFromSatrec(satrec, time.add(i, "second"));
    if (!position) continue;
    const { x, y, z } = position;
    arr.push(x, y, z);
  }

  // for (let i = -12 * 60 * 5; i < 12 * 60 * 5; i++) {
  //   const position = getPositionFromSatrec(satrec, time.add(i, 'second'));
  //   if (!position) continue;
  //   const { x, y, z } = position;
  //   arr.push(x, y, z);
  // }
  return arr;
};
